import Page from "../components/Page";
import React, { useState } from "react";
import { useLocation } from "react-router";
import { useEffect } from "react";
import { IonCol, IonLabel, IonRow, IonToast } from "@ionic/react";

const Contact: React.FC = () => {
  return (
    <Page title="Contact">
      <ContactForm />
    </Page>
  );
};

const ContactForm: React.FC = () => {
  const location = useLocation();
  // const [active, setActive] = useState(0);
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [errors, setErrors] = useState<Array<string>>([]);
  const [ip, setIp] = useState("");

  useEffect(() => {
    const ipAddress = new IpServiceService();
    ipAddress
      .getIPAddress()
      .then(({ ip }) => setIp(ip))
      .catch((error: any) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    console.log(ip);
  }, [ip]);

  const onSubmit = async (event: any) => {
    event.preventDefault();
    if (message === "" && phone === "" && name === "") {
      setErrors(["Please fill out all fields"]);
    }
    if (message === "" && phone !== "" && name !== "") {
      setErrors([...errors, "Message is required"]);
    }
    if (message !== "" && phone === "" && name !== "") {
      setErrors([...errors, "Phone is required"]);
    }
    if (message !== "" && phone !== "" && name === "") {
      setErrors([...errors, "Name is required"]);
    }
    if (message !== "" && phone !== "" && name !== "") {
      const response = await fetch(
        "https://us-central1-iwatchtv.cloudfunctions.net/Twilio/api/sms?name=" +
          name +
          "&ip=" +
          ip +
          "&phone=" +
          phone +
          "&message=" +
          message +
          "&to=+17865850481",
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Allow-Control-Allow-Origin": "*",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      const data = await response.json();
      if (!data.errorCode) {
        console.log(data);
        setErrors([]);
        setName("");
        setPhone("");
        setMessage("");
        console.log("Form submitted");
        alert("Thank you for contacting me, I will get back to you soon!");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setErrors([data.errorMessage]);
      }
    }
  };

  return (
    <IonRow>
      <IonCol
        size=""
        sizeXs=""
        sizeSm=""
        sizeMd=""
        sizeLg=""
        sizeXl="3"
      ></IonCol>
      <IonCol
        size="12"
        sizeXs="12"
        sizeSm="10"
        sizeMd="8"
        sizeLg="7"
        sizeXl="6"
      >
        <div className="flex flex-col">
          <div className="flex flex-col m-[10px]">
            <input
              value={name}
              name="name"
              onChange={(e) => setName(e.target.value)}
              className="border border-gray-300 rounded-lg p-2"
              type="text"
              placeholder="Name"
            />
          </div>
          <div className="flex flex-col m-[10px]">
            <input
              value={phone}
              name="phone"
              type="tel"
              onChange={(e) => setPhone(e.target.value)}
              className="border border-gray-300 rounded-lg p-2"
              placeholder="Phone #"
            />
          </div>
          <div className="flex flex-col m-[10px]">
            <textarea
              value={message}
              name="message"
              onChange={(e) => setMessage(e.target.value)}
              className="border border-gray-300 rounded-lg p-2"
              placeholder="Message"
            ></textarea>
          </div>
          <div className="flex flex-col m-[10px]">
            <button
              onClick={onSubmit}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg"
            >
              Submit
            </button>
          </div>
          <IonToast
            duration={3000}
            color="danger"
            onDidDismiss={() => setErrors([])}
            isOpen={errors[0]?.length > 0}
            message={errors[0]}
          />
          {/* <IonToast
            duration={3000}
            color="danger"
            isOpen={errors[1]?.length > 0}
            message={errors[1]}
          />
          <IonToast
            duration={3000}
            color="danger"
            isOpen={errors[2]?.length > 0}
            message={errors[2]}
          /> */}
        </div>
      </IonCol>
      <IonCol
        size=""
        sizeXs=""
        sizeSm=""
        sizeMd=""
        sizeLg=""
        sizeXl="3"
      ></IonCol>
    </IonRow>
  );
};

export default Contact;

export class IpServiceService {
  public async getIPAddress(): Promise<{ ip: string }> {
    const response = await fetch("https://api.ipify.org?format=json");
    return await response.json();
  }
}
